import { render } from "./Childering.vue?vue&type=template&id=0d19c388"
import script from "./Childering.vue?vue&type=script&lang=js"
export * from "./Childering.vue?vue&type=script&lang=js"

import "./Childering.vue?vue&type=style&index=0&id=0d19c388&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__